import React from 'react';
import { Wrapper, Container } from './style';
import { getNoToken } from '../../utils/request';
import { Toast,DatePicker,List } from 'antd-mobile';
import Config from '../../config';
import moment from 'moment';
import bg_06 from '../../assets/images/bg_06.png';

class PregnCalculat1 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      index: 0,
      list: [
        {id: 0,name: '自然妊娠',text: '',title: '末次月经第一天'},
        {id: 1,name: '胚胎移植',text: '(三天胚)',title: '胚胎移植日期'},
        {id: 2,name: '囊胚移植',text: '(五天胚)',title: ' 囊胚移植日期'}
      ],
      date: ''
    }
  }
  async componentDidMount() {
    document.title = '水母来了-孕周计算器'
    let res = await this.loadWxConfig();
    if(res.data.code == 100){
      window.wx.config({
        debug: false,
        ...res.data.data,
        jsApiList: ['onMenuShareTimeline','onMenuShareAppMessage','updateTimelineShareData','updateAppMessageShareData']
      });
    } else {
      Toast.info('配置微信分享异常')
    }
    window.wx.ready(() => {
      //分享朋友圈
      window.wx.onMenuShareTimeline({
        title: '水母来了-孕周计算器，孕期状态早知道',
        link: `${Config.HTTP_HOST_SMLL}/pregnCalculat1`,
        imgUrl: 'http://img.bangivf.com/images/yunzhoujisuanqi.png',
        success: res => {},
        cancel: err => {}
      })
      //分享给朋友
      window.wx.onMenuShareAppMessage({
        title: '水母来了-孕周计算器，孕期状态早知道',
        desc: '方便快捷完成您的预产期计算，提早为宝宝降临做准备',
        link: `${Config.HTTP_HOST_SMLL}/pregnCalculat1`,
        imgUrl: 'http://img.bangivf.com/images/yunzhoujisuanqi.png',
        type: '', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: res => {},
        cancel: err => {}
      })
      //分享朋友圈
      window.wx.updateTimelineShareData({
        title: '水母来了-孕周计算器，孕期状态早知道',
        link: `${Config.HTTP_HOST_SMLL}/pregnCalculat1`,
        imgUrl: 'http://img.bangivf.com/images/yunzhoujisuanqi.png',
        success: res => {},
        cancel: err => {}
      })
      //分享给朋友
      window.wx.updateAppMessageShareData({
        title: '水母来了-孕周计算器，孕期状态早知道',
        desc: '方便快捷完成您的预产期计算，提早为宝宝降临做准备',
        link: `${Config.HTTP_HOST_SMLL}/pregnCalculat1`,
        imgUrl: 'http://img.bangivf.com/images/yunzhoujisuanqi.png',
        type: '', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: res => {},
        cancel: err => {}
      })
    })
  }
  async loadWxConfig(){
    let appid = Config.appId
    let url = window.location.href.split('#')[0]
    let params = {appid, url}
    let res = await getNoToken(`/pgy/user/${Config.appId}/jsapiTicket`, params)
    return res
  }
  goNext(){
    let date = this.state.date
    let time = moment(date).format('YYYY-MM-DD')
    let index = this.state.index
    if(!date){
      Toast.info('请先选择日期')
      return false
    }
    if(index == 1){
      time = this.dateChange(-17, time)
    } else if(index == 2){
      time = this.dateChange(-19, time)
    }
    this.props.history.push(`/pregnCalculat2/${index}/${time}`)
  }
  dateChange(num,date){
    if (!date){
      date = new Date();//没有传入值时,默认是当前日期
      date = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    }
    //date += " 00:00:00";//设置为当天凌晨12点
    date = Date.parse(new Date(date))/1000;//转换为时间戳
    date += (86400) * num;//修改后的时间戳
    var newDate = new Date(parseInt(date) * 1000);//转换为时间
    //return newDate.getFullYear() + '-' + (newDate.getMonth() + 1) + '-' + newDate.getDate();
    return moment(newDate).format('YYYY-MM-DD')
  }
  render() {
    let { list,index } = this.state;
    return (
      <Wrapper>
        <Container>
          <img className="banner" src={bg_06} />
          <div className="list">
            {list.map((v, i) => (
              <div className={`item ${index==i?'active':''}`} key={`key-list-${i}`} onClick={()=>this.setState({index: i})}>
                <div className="child">
                  <div className="text">
                    <p>{v.name}</p><span>{v.text}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="title">{list[index].title}</div>
          <div className="times">
            <div className="label">选择日期</div>
            <div className="picker">
              <DatePicker mode="date" title="请选择日期" extra="" value={this.state.date} onChange={date => this.setState({ date })} >
                <List.Item></List.Item>
              </DatePicker>
            </div>
          </div>
          <div className="btns">
            <div className="btn" onClick={()=>this.goNext()}>开始计算</div>
          </div>
        </Container>
      </Wrapper>
    );
  }
}
export default PregnCalculat1;